/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  'feedback-collector.anonymous': 'This feedback is being submitted anonymously. Atlassian will not be able to contact you directly regarding this feedback',
  'feedback-collector.anonymous.title': 'Anonymous feedback',
  'feedback-collector.can-be-contacted.label': 'Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the <a>Atlassian Privacy Policy</a>.',
  'feedback-collector.cancel-button.label': 'Cancel',
  'feedback-collector.default.custom.textarea.label': "What's on your mind?",
  'feedback-collector.enrol-in-research.label': "I'd like to participate in product research",
  'feedback-collector.feedback-title': 'Share your thoughts',
  'feedback-collector.form.bug.label': 'Describe the bug or issue',
  'feedback-collector.form.comment.label': "Let us know what's on your mind",
  'feedback-collector.form.empty.label': 'Select an option',
  'feedback-collector.form.question.label': 'What would you like to know?',
  'feedback-collector.form.suggestion.label': "Let us know what you'd like to improve",
  'feedback-collector.option.bug.label': 'Report a bug',
  'feedback-collector.option.comment.label': 'Leave a comment',
  'feedback-collector.option.default.label': 'Select feedback',
  'feedback-collector.option.default.placeholder': 'Choose one',
  'feedback-collector.option.question.label': 'Ask a question',
  'feedback-collector.option.suggestion.label': 'Suggest an improvement',
  'feedback-collector.required.fields.summary': 'Required fields are marked with an asterisk',
  'feedback-collector.submit-button.label': 'Send feedback',
  'feedback-collector.success-flag.description': 'Your valuable feedback helps us continually improve our products.',
  'feedback-collector.success-flag.title': 'Thanks!',
  'feedback-collector.summary-placeholder': "Let us know what's on your mind",
  'proforma-form-builder.feedback-icon-label': 'Feedback',
  'proforma-form-builder.give-feedback': 'Give feedback'
};